import { render, staticRenderFns } from "./addressCascade.vue?vue&type=template&id=25c13e01&name=myAddressCascade&"
import script from "./addressCascade.vue?vue&type=script&lang=js&"
export * from "./addressCascade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports